export const PrimitiveTypes = ['boolean', 'number', 'string', 'undefined', 'bigint', 'symbol'];
export const NonPrimitiveTypes = ['array', 'object', 'function', 'map'];
export function isPrimitive(input) {
  if (input === null) return true;
  if (PrimitiveTypes.includes(typeof input)) return true;
  return false;
}